// extracted by mini-css-extract-plugin
module.exports = {"wrap":"GRav","imgBg":"GRabf","image":"GRob","textBox":"GRabh","label":"GRt7","title":"GRal","statistic":"GRa5","advLabel":"GRkh"};